import EasyPassClient from './EasyPassClient';

class MultibuyerToolsClient {
  constructor(user) {
    const headers = {
      'json-naming-strategy': 'camel',
    };
    this.easyPassClient = new EasyPassClient(user, null, headers);
    this.apiVersion = 'v3';
    this.gatewayUri = 'api/acvapi';
    this.resourceUri = 'auctions';
  }

  fetchDealershipsThatCanPlaceHoldOnAuctions() {
    return this.easyPassClient.get(`${this.gatewayUri}/${this.apiVersion}/${this.resourceUri}/dealers_can_claim`);
  }

  placeHoldOnAuctionForDealership({ auctionId, dealerId }) {
    return this.easyPassClient.post(`${this.gatewayUri}/${this.apiVersion}/${this.resourceUri}/${auctionId}/claim`, { dealerId });
  }

  removeHoldOnAuctionForDealership(auctionId) {
    return this.easyPassClient.delete(`${this.gatewayUri}/${this.apiVersion}/${this.resourceUri}/${auctionId}/claim`);
  }
}

export default MultibuyerToolsClient;
